import { Lookup } from '../models/lookup';
import { SortDescriptor } from '@progress/kendo-data-query';
import { SentEmailsDocumentsLookup } from './sent-emails-documents-lookup';

export class SentEmailsLookup extends Lookup {
  id: string = null;
  from: string = null;
  to: string = null;
  cc: string = null;
  bcc: string = null;
  replyTo: string = null;
  skipSending: boolean = null;
  template: Array<string> = [];
  subject: string = null;
  fromDateTime: Date = null;
  toDateTime: Date = null;

  //will be mapped to documents
  aircraft: string = null;
  operator: string = null;
  user: string = null;
  operatorPurchaseOffer: string = null;
  sourcingRequest: string = null;

  documents: Array<SentEmailsDocumentsLookup> = null;
  limit = 10;
  sort: Array<SortDescriptor> = [{ field: 'sent', dir: 'desc' }];

  constructor(data?: any) {
    super(data);
    if (data) {
      this.id = this.parseString(data.id);
      this.from = this.parseString(data.from);
      this.to = this.parseString(data.to);
      this.cc = this.parseString(data.cc);
      this.bcc = this.parseString(data.bcc);
      this.replyTo = this.parseString(data.replyTo);
      this.subject = this.parseString(data.subject);
      this.skipSending = this.parseBoolean(data.skipSending);
      this.template = this.parseArray<string>(data.template);
      this.fromDateTime = this.parseDate(data.fromDateTime);
      this.toDateTime = this.parseDate(data.toDateTime);

      this.aircraft = this.parseString(data.aircraft);
      this.operator = this.parseString(data.operator);
      this.user = this.parseString(data.user);
      this.operatorPurchaseOffer = this.parseString(data.operatorPurchaseOffer);
      this.sourcingRequest = this.parseString(data.sourcingRequest);
    }
  }
}
